var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimImageNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5B6673;}\r\n\t.st1{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M839.4,68.3c-4.9-2.8-10.4-4.3-16-4.3H687.1c-8.2,0-15.1,6.2-15.9,14.4C664,142.2,609.7,192,544,192 S424,142.2,416.8,78.4c-0.9-8.2-7.7-14.3-15.9-14.4H264.6c-5.6,0-11.1,1.5-16,4.3L73.4,169.4c-5.7,3.3-8.8,9.7-7.8,16.2 l36.6,248.8c1.2,7.8,7.9,13.7,15.8,13.7h138v368c0,8.8,7.2,16,16,16h544c8.8,0,16-7.2,16-16V448h138c7.9,0,14.7-5.8,15.8-13.7 l36.6-248.8c1-6.5-2.1-12.9-7.8-16.2L839.4,68.3z M929.6,384H768v384H320V384H158.4l-23.8-174.8L272,128h91 c26.4,74.5,97.6,128,181,128s154.6-53.5,181-128h91l137.4,81.2L929.6,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1215.8,569.6l-36.6,248.8c-1.2,7.9-7.9,13.7-15.8,13.7h-138v368c0,8.8-7.2,16-16,16h-544 c-8.8,0-16-7.2-16-16V912c0-8.8,7.2-16,16-16h32c8.8,0,16,7.2,16,16v240h448V768H1123l23.8-174.8l-110.5-65.3 c-2.8-1.7-4.3-4.8-3.8-8.1l7.5-50.1c0.7-4.4,4.7-7.4,9.1-6.7c1,0.1,1.9,0.5,2.8,1l156.2,89.4 C1213.7,556.7,1216.8,563.1,1215.8,569.6z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1024,
    y1: 176,
    x2: 976,
    y2: 496
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1280,
    height: 1280
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimImageNormal);
export default __webpack_public_path__ + "static/media/sim_image_normal.eebd296d1d1cee22f74e2f7a1085d4a7.svg";
export { ForwardRef as ReactComponent };